import {
  formatPurchasePlanningNumber,
  getPurchaseRoundingExceptionBadgeClass,
} from '../../../lib/purchasePlanningHelpers';

export function PurchaseRoundingMainTable({ rows, selectedRowId, onSelectRow }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="max-h-[calc(100vh-18rem)] overflow-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="sticky top-0 z-10 bg-slate-50 text-xs uppercase tracking-[0.12em] text-gray-500">
            <tr>
              <th className="px-4 py-3 font-medium">Supply SKU</th>
              <th className="px-4 py-3 font-medium">Product</th>
              <th className="px-4 py-3 font-medium">Supplier / Group</th>
              <th className="px-4 py-3 text-right font-medium">OTB</th>
              <th className="px-4 py-3 text-right font-medium">MOQ</th>
              <th className="px-4 py-3 text-right font-medium">Carton</th>
              <th className="px-4 py-3 text-right font-medium">Base buy</th>
              <th className="px-4 py-3 text-right font-medium">Group base</th>
              <th className="px-4 py-3 text-right font-medium">Containers</th>
              <th className="px-4 py-3 text-right font-medium">Container units</th>
              <th className="px-4 py-3 text-right font-medium">Fill alloc.</th>
              <th className="px-4 py-3 text-right font-medium">Adjusted rounded</th>
              <th className="px-4 py-3 text-right font-medium">Delta</th>
              <th className="px-4 py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map(row => (
                <tr
                  key={row.id}
                  className={`cursor-pointer border-b border-gray-100 hover:bg-gray-50 ${
                    selectedRowId === row.id ? 'bg-slate-50/80' : ''
                  }`}
                  onClick={() => onSelectRow?.(row.id)}
                >
                  <td className="px-4 py-3 align-top font-medium text-gray-900">{row.supplySku}</td>
                  <td className="px-4 py-3 align-top text-gray-600">
                    <p className="font-medium text-gray-900">{row.productName}</p>
                    <p className="mt-1 text-xs text-gray-500">
                      {row.category} · {row.subCategory}
                    </p>
                  </td>
                  <td className="px-4 py-3 align-top text-gray-600">
                    <p>{row.supplier}</p>
                    <p className="mt-1 text-xs text-gray-500">{row.containerGroup || 'Ungrouped'}</p>
                    <p className="mt-1 text-[11px] text-gray-500">{row.roundingType}</p>
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.otbUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.moq)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.cartonQty)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.baseBuyUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.groupBaseBuy)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.containers)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.containerUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.fillAllocatedUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(row.adjustedRoundedUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(row.roundingDelta)}
                  </td>
                  <td className="px-4 py-3 align-top">
                    <span
                      className={`inline-flex rounded-md px-2 py-1 text-[11px] font-medium ${getPurchaseRoundingExceptionBadgeClass(row.exceptionTypes)}`}
                    >
                      {row.exceptionSummary}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="px-4 py-8 text-sm text-gray-500" colSpan={14}>
                  No purchase-rounding rows match the current filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
